import React, {forwardRef} from 'react'
import {TwIcon} from '../containers'
import {TwBoardButton, TwText} from './containers'
import {BoardButtonProps} from './types'

export const BoardButton = forwardRef(
  (
    {
      title,
      hint,
      icon,
      onClick,
      forcedState,
      disabled,
      className,
      children,
      noBorder
    }: BoardButtonProps,
    ref
  ) => (
    <TwBoardButton
      ref={ref}
      role="button"
      content={hint}
      $disabled={disabled}
      $forcedState={forcedState}
      $noBorder={noBorder}
      className={className}
      onClick={!disabled ? onClick : undefined}
    >
      {icon && <TwIcon icon={icon} viewBox="0 0 24 24" />}
      {children ?? (title && <TwText>{title}</TwText>)}
    </TwBoardButton>
  )
)
